const rules = {
  global: {
    dashboard: { roles: ["globalAdmin"] },
    listUsers: { roles: ["globalAdmin"] },
    globalDictionary: { roles: ["globalAdmin"] },
    listBrands: { roles: ["globalAdmin"] },
    devices: { roles: ["globalAdmin"] },
    templates: { roles: ["globalAdmin"] },
  },
  brands: {
    dashboard: {
      roles: ["globalAdmin", "brandReseller", "brandOwner", "brandAdmin", "brandManager", "brandShiftManager", "brandUser", "brandEditor"],
    },
    listOpenHours: {
      roles: ["globalAdmin", "brandOwner", "brandAdmin", "brandManager", "brandShiftManager"],
    },
    listLocations: {
      roles: ["globalAdmin", "brandReseller", "brandOwner", "brandAdmin"],
    },
    listLocationsEnabled: { roles: ["globalAdmin"] },
    listLocationsIntegration: { roles: ["globalAdmin",  "brandOwner", "brandAdmin"] },
    listUsers: { roles: ["globalAdmin", "brandReseller", "brandOwner", "brandAdmin"] },
    listTables: { roles: ["globalAdmin", "brandOwner", "brandAdmin", "brandManager"] },
    listOrders: {
      roles: ["globalAdmin", "brandOwner", "brandAdmin", "brandManager", "brandShiftManager", "brandReseller"],
    },
    listTemplates: { roles: ["globalAdmin", "brandOwner", "brandAdmin"] },
    listDictionary: { roles: ["globalAdmin", "brandOwner", "brandAdmin"] },
    listCatalog: {
      roles: ["globalAdmin", "brandOwner", "brandAdmin", "brandManager", "brandShiftManager", "brandReseller"],
    },
    listDevices: { roles: ["globalAdmin", "brandOwner", "brandAdmin", "brandReseller"] },
    listPrinters: { roles: ["globalAdmin", "brandOwner", "brandAdmin", "brandReseller"] },
    listPayments: { roles: ["globalAdmin", "brandReseller", "brandOwner", "brandAdmin"] },
    listPaymentAgents: {
      roles: ["globalAdmin", "brandReseller", "brandOwner", "brandAdmin"],
    },
    listOnlineProfiles: { roles: ["globalAdmin", "brandReseller", "brandOwner", "brandAdmin"] },
    listInvoiceProfiles: { roles: ["globalAdmin", "brandReseller", "brandOwner", "brandAdmin"] },
    listItems: { roles: ["globalAdmin", "brandOwner", "brandAdmin", "brandReseller"] },
    listItemAvailability: {
      roles: ["globalAdmin", "brandOwner", "brandAdmin", "brandManager", "brandShiftManager", "brandReseller"],
    },
    listNews: { roles: ["globalAdmin", "brandOwner", "brandAdmin"] },
    rebuildCache: { roles: ["globalAdmin", "brandOwner", "brandAdmin"] },
    createTable: { roles: ["globalAdmin", "brandOwner", "brandAdmin", "brandManager"] },
    reports: { roles: ["globalAdmin", "brandOwner", "brandAdmin"] },
    listSanitycheck: { roles: ["globalAdmin", "brandOwner", "brandAdmin"] },
    listNtak: { roles: ["globalAdmin"] },
    listLocationIntegrations: {roles:["globalAdmin", "brandReseller"]},
    listErrorLogs: { roles: ["globalAdmin", "brandReseller", "brandOwner", "brandAdmin", "brandManager"] },
    listContents: { roles: ["globalAdmin", "brandOwner", "brandAdmin"] },
    listDiscounts: { roles: ["globalAdmin", "brandOwner", "brandAdmin"] },
    appEditor: { roles: ["globalAdmin", "brandOwner", "brandAdmin", "brandEditor"] },
    listModifierExtIdSchema: {roles:["globalAdmin", "brandReseller", "brandOwner", "brandAdmin"]},
    listItemExtIdSchema:{roles:["globalAdmin", "brandReseller", "brandOwner", "brandAdmin"]},
    listIntegrationSchemas: {roles:["globalAdmin", "brandReseller", "brandOwner", "brandAdmin"]},
  },
  vip: {
    listCardTypes: { roles: ["globalAdmin", "vipAdmin"] },
    listCoupons: { roles: ["globalAdmin", "vipAdmin"] },
    listCustomers: { roles: ["globalAdmin", "vipAdmin"] },
    listItems: { roles: ["globalAdmin", "vipAdmin"] },
    listPurchases: { roles: ["globalAdmin", "vipAdmin"] },
    listStores: { roles: ["globalAdmin", "vipAdmin"] },
    listTemplates: { roles: ["globalAdmin", "vipAdmin"] },
    listTransactions: { roles: ["globalAdmin", "vipAdmin"] },
    readVipBrand: { roles: ["globalAdmin", "vipAdmin"] },
    readAllVipBrands: { roles: ["globalAdmin", "vipAdmin"] },
    createCardTypes: { roles: ["globalAdmin", "vipAdmin"] },
    createCoupons: { roles: ["globalAdmin", "vipAdmin"] },
    createStores: { roles: ["globalAdmin", "vipAdmin"] },
    createCustomers: { roles: ["globalAdmin", "vipAdmin"] },
    updateItems: { roles: ["globalAdmin", "vipAdmin"] },
    updateCustomerPoints: { roles: ["globalAdmin", "vipAdmin"] },
    uploadAsset: { roles: ["globalAdmin", "vipAdmin"] },
    sendNewsletter: { roles: ["globalAdmin", "vipAdmin"] },
  },
  reseller: {
    listBrands: { roles: [] },
    listCommissions: { roles: [] },
    listInvitation: { roles: [] },
    listBrandInits: { roles: [] },
    billing: { roles: [] },
  },
}

function checkPermission(rule, roles) {
  try {
    if (rule.roles?.length === 0) return true
    return rule.roles.some((role) => roles.includes(role))
  } catch (e) {
    return false
  }
}

function canUseFeature(user, app, feature, appID = null, appSubID = null, anySubID = false) {
  if (user == null) return false
  if (user.roles.includes("globalAdmin")) return true
  if (
    user?.resellerCode != null &&
    user?.resellerCode !== "" &&
    (feature === "listLocations" ||
      feature === "listTables" ||
      feature === "listOpenHours" ||
      feature === "listDictionary" ||
      feature === "listDiscounts" ||
      feature === "listOnlineProfiles" ||
      feature === "listInvoiceProfiles")
  )
    return true
  let rule
  try {
    rule = rules[app][feature]
    if (rule == null) return false
  } catch (e) {
    return false
  }
  try {
    if (checkPermission(rule, user.roles)) {
      return true
    }
  } catch (e) {}
  try {
    if (appID == null) return false
    let appRoles = user.apps[app][appID].roles
    if (checkPermission(rule, appRoles)) return true

    if (user.apps[app][appID].subApps != null) {
      // Check also appSubID persmissions
      if (appSubID == null) {
        if (anySubID) {
          for (let roles of Object.values(user.apps[app][appID].subApps)) {
            //console.log(rule, roles, checkPermission(rule, roles))
            if (checkPermission(rule, roles)) return true
          }
        } else return false
      } else {
        let appSubRoles = user.apps[app][appID].subApps[appSubID]
        if (checkPermission(rule, appSubRoles)) return true
      }
    }
  } catch (e) {
    //okelog.log(e)
    return false
  }
  return false
}

export { canUseFeature }
